export const menus  = [
    { name: '复制文本', command: 'copy' },
    { name: '新增节点', command: 'add' },
    { name: '编辑节点', command: 'edit' },
    { name: '删除节点', command: 'delete' }
]